import { useQuery } from '@tanstack/react-query';
import { getActaByTemporadaAndCodActa } from '../../services/actasService';

/**
 * Hook para obtener el acta de un partido por temporada y código de acta
 * @param {number} idTemporada - ID de la temporada
 * @param {string} codActa - Código del acta
 * @param {object} options - Opciones de React Query
 */
export const useActaPartido = (idTemporada, codActa, options = {}) => {
  return useQuery({
    queryKey: ['acta', idTemporada, codActa],
    queryFn: () => getActaByTemporadaAndCodActa(idTemporada, codActa, null),
    enabled: !!(idTemporada && codActa),
    staleTime: 10 * 60 * 1000, // 10 minutos (datos de actas no cambian frecuentemente)
    ...options,
  });
};

export default useActaPartido;
